import { P } from "common/P/P";
import React, { useState, useRef, ChangeEvent, useEffect } from "react";
import { ReactComponent as UploadIcon } from "common/assets/icons/upload.svg";
import { ReactComponent as CloseIcon } from "common/assets/icons/x.svg";
import axios from "axios";
import { serviceConfig } from "configs";

interface FileUploadProps {
	gap?: string;
	files?: File[] | any;
	onChange: (event: any) => void;
	renderFilePaths?: boolean;
	label?: string;
	onFileDelete?: any;
	letterId?: any;
	type?: any;
}

const FileUpload: React.FC<FileUploadProps> = ({
	gap,
	files,
	onChange,
	renderFilePaths,
	label = "Baglanyşykly hatlar",
	onFileDelete,
	letterId,
	type,
}) => {
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const fileInputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (files) {
			setSelectedFiles(files);
		}
	}, [files]);

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files) {
			const filesArray = Array.from(event.target.files);
			setSelectedFiles([...selectedFiles, ...filesArray]);
			onChange && onChange(event); // Call the onChange prop function
		}
	};

	const openFileDialog = () => {
		fileInputRef.current?.click();
	};

	const removeFile = async (index: number, file: any) => {
		if (typeof file === "string") {
			// Handle backend file deletion
			try {
				await axios.post(`${serviceConfig.apiUrl}/delete-file`, {
					letterId: letterId,
					filePath: file,
					type: type,
				});
				onFileDelete && onFileDelete(file);
			} catch (error) {
				console.error("Failed to delete file:", error);
			}
		}
		const updatedFiles = selectedFiles.filter((_, i) => i !== index);
		setSelectedFiles(updatedFiles);
		onChange(updatedFiles); // Pass the updated files array directly
	};

	return (
		<div className={`grid grid-cols-1 ${gap ? gap : "gap-6"} `}>
			<div className="px-2 py-1 border rounded-md border-strokeColor">
				<input
					type="file"
					ref={fileInputRef}
					className="hidden"
					accept=".xlsx, .docx, .pdf"
					onChange={handleFileChange}
					multiple
				/>
				<div
					className="grid gap-2 px-[14px] py-[6px] transition-all duration-300 cursor-pointer grid-cols-maxTwo bg-mainColor hover:opacity-90 rounded-md w-max"
					onClick={openFileDialog}
				>
					<UploadIcon />
					<P size="t1" type="medium" className="text-white cursor-pointer">
						Faýl ýükläň
					</P>
				</div>
			</div>
			{selectedFiles && selectedFiles.length > 0 && (
				<div className="grid grid-cols-1 gap-1">
					<P size="t1" type="regular" className="">
						{label}
					</P>
					<div className="flex flex-wrap gap-2 px-2 py-2 border rounded-md border-strokeColor">
						{selectedFiles.map((file: any, index: number) => {
							// const fileName =
							// 	renderFilePaths && typeof file === "string"
							// 		? file.split("/").pop()
							// 		: file instanceof File
							// 		? file.name
							// 		: "";
							const fileName = file.name || file;

							console.log("FILEEE", file);
							return (
								<div
									key={index}
									className="flex items-center gap-2 px-3 py-1 rounded bg-lowOpacity"
								>
									<P size="t1" type="medium" className="text-mainColor">
										{fileName}
									</P>
									<CloseIcon
										onClick={() => removeFile(index, file)}
										className="w-4 h-4 cursor-pointer stroke-mainColor"
									/>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default FileUpload;
